import { getUrlParam } from './params';
import { detectRegistrationOriginPage } from './originPage';

const STORAGE_KEY = 'mlabs_marketing_params';

export const MARKETING_PARAM_KEYS = [
  'gclid',
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_placement',
  'origin_page',
  'origin_click',
];

const getCookie = (key) => {
  const keyInfo = document.cookie.split('; ').find((row) => row.startsWith(key));

  if (keyInfo) {
    return decodeURIComponent(keyInfo.split('=').slice(1).join('='));
  }

  return undefined;
};

const readFromUrlAndCookies = () => {
  const params = {};

  for (const key of MARKETING_PARAM_KEYS) {
    const value = getCookie(`${key}=`) || getUrlParam(key);
    if (value) {
      params[key] = value;
    }
  }

  return params;
};

const readFromStorage = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeToStorage = (params) => {
  try {
    const merged = { ...readFromStorage(), ...params };
    const hasValues = MARKETING_PARAM_KEYS.some((key) => merged[key]);

    if (hasValues) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    }
  } catch {
    /* ignore */
  }
};

const resolveOriginPage = (fromUrlAndCookies, stored) => {
  if (fromUrlAndCookies.origin_page || stored.origin_page) {
    return undefined;
  }

  return detectRegistrationOriginPage();
};

export const persistMarketingParams = () => {
  const fromUrlAndCookies = readFromUrlAndCookies();
  const stored = readFromStorage();
  const detectedOriginPage = resolveOriginPage(fromUrlAndCookies, stored);

  writeToStorage({
    ...fromUrlAndCookies,
    ...(detectedOriginPage ? { origin_page: detectedOriginPage } : {}),
  });
};

export const getMarketingParamsFromObject = (source = {}) => {
  const params = {};

  for (const key of MARKETING_PARAM_KEYS) {
    if (source[key]) {
      params[key] = source[key];
    }
  }

  return params;
};

export const getMarketingParams = () => {
  const fromUrl = readFromUrlAndCookies();
  writeToStorage(fromUrl);

  const stored = readFromStorage();
  const params = {};

  for (const key of MARKETING_PARAM_KEYS) {
    const value = fromUrl[key] || stored[key];
    if (value) {
      params[key] = value;
    }
  }

  if (!params.origin_page) {
    params.origin_page = detectRegistrationOriginPage();
    writeToStorage({ origin_page: params.origin_page });
  }

  return params;
};
